// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"440":"dce3ee94","459":"e6af57d8","545":"f6a21945","625":"dce3ee94","665":"dce3ee94","748":"198f4143","891":"8fbcece7"}[chunkId] + ".chunk.css";
};